// extracted by mini-css-extract-plugin
export default {"topBar":"Card_topBar__XbpgF","titleBlock":"Card_titleBlock__8L+cf"};